import { BrowserRouter, Routes, Route } from "react-router-dom";
import React from 'react';
import "./App.css";
import Footer from "./components/common/footer/Footer";
import { Theme } from "./components/common/theme/Theme";
import Header from "./components/header/Header";
import Dashboard from "./views/dashboard/Dashboard";
import CreateDebi from "./views/newDebi/CreateDebi";
import DebiDetails from "./views/debiDetails/DebiDetails";
import Maintenance from "./views/maintenance/Maintenance";
import Report from "./components/reporting/Report";
import Login from "./components/authentication/Login";
import RestrictRoute from "./views/restrictRoute/RestrictRoute";
import NoRole from "./views/norole/NoRole";
import { DEBI_ROLE, FEEDBACK_BTN_STYLE } from './utils/constants/GlobalConstants';
import ButtonLayout from "./components/common/button/ButtonLayout";
import DialogView from "./components/common/dialogView/DialogView";
import ReportIssue from "./components/common/reportIssue/ReportIssue";
import { useMediaQuery, useTheme } from "@mui/material";
function App() {
  // const resultRef = useRef();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [reportIssue, setReportIssue] = React.useState(false);
  const handleReportIssue = () => {
    setReportIssue(false);
  };

  const handleOpenReportDialog = () => {
    setReportIssue(true);
  };
  return (
    <Theme>
      <BrowserRouter>
        <div className="App">
        <DialogView
          from={"parts"}
          open={reportIssue}
          handleClose={() => handleReportIssue()}
          width={isMobile ? "70%" : "30%"}
          maxWidth={"75em!important"}
          heading={"Feedback"}
          testid={"reportIssue"}
          childComponet={<ReportIssue />}
        />
        <ButtonLayout
              label={"Feedback"}
              sx={{
                ...FEEDBACK_BTN_STYLE,
              }}
              onClickBtn={() => handleOpenReportDialog()}
              testid={"reportBtn"}
            />
          <Header />
          <Routes>
            <Route element={<RestrictRoute isAuthenticated={[DEBI_ROLE.SALES_REP, DEBI_ROLE.DC_CONTACT,DEBI_ROLE.PARTS_ADMIN]} redirectTo="/debi-tool/home" />}>
              <Route exact path="/debi-tool/export-excel" Component={Report} />
              <Route exact path="/debi-tool/maintenance" Component={Maintenance} />
              <Route exact path="/debi-tool/createdebi" Component={CreateDebi} />
            </Route>
            <Route element={<RestrictRoute isAuthenticated={[DEBI_ROLE.SALES_REP, DEBI_ROLE.STORE_AGENT, DEBI_ROLE.DC_CONTACT,DEBI_ROLE.PARTS_ADMIN]} redirectTo="/debi-tool/norole" />}>
              <Route exact path="/" Component={Dashboard} />
              <Route exact path="/debi-tool/home" Component={Dashboard} />
              <Route exact path="/debi-tool/requests" Component={Dashboard} />
              <Route exact path="/debi-tool/details/:id" Component={DebiDetails} />
              <Route exact path="*" Component={Login} />
              <Route exact path="/debi-tool/details" Component={DebiDetails} />
            </Route>
            <Route exact path="/debi-tool/login" Component={Login} />
            <Route exact path="/debi-tool/norole" Component={NoRole} />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
    </Theme>


  );
}

export default App;